module.exports = {
      id: "arrow-usage",
      viewBox: "0 0 8.063 11.15",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#arrow",
      toString: function () {
        return this.url;
      }
    }